import React from 'react';

import MultiCurrencyMenu from '../controls/multi-currency-menu';

const ShopViewPriceBlock = (props) => (
  <div className="product-view__meta-block">
    <span className={
        'product-view__meta-label ' +
        ((props.data.Discount_Price_Profile) ? 'product-view__discount-label ' : '')
      }
    >
      {(props.data.Discount_Price_Profile && props.data.Discount_Price_Tag) ? (
        <>{props.data.Discount_Price_Tag}</>
      ) : (
        "Price"
      )}
    </span>
    <span className="product-view__meta-value product-view__meta-value__currency-bar">
      {(props.cartCurrency) ? (
        <div>
          {(props.data.Discount_Price_Profile) ? (
            <>
              <span className="product-view__discount-strike">
                {props.formattedPrice(props.calculatedPrice(props.data.Price_Profile[0]))}
              </span>
              <span className="product-view__discount-price">
                {props.formattedPrice(props.calculatedPrice(props.data.Discount_Price_Profile[0]))}
              </span>
            </>
          ) : (
            props.formattedPrice(props.calculatedPrice(props.data.Price_Profile[0]))
          )}
        </div>
      ) : <div></div>}
      <div>
        <MultiCurrencyMenu
          onMultiCurrencyChange={props.onMultiCurrencyChange}
          cartCurrency={props.cartCurrency}
        />
      </div>
    </span>
  </div>
);

export default ShopViewPriceBlock;